var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHamburg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8889 22.1111H6.88889C5.84622 22.1111 5 22.9573 5 24C5 25.0446 5.84622 25.8889 6.88889 25.8889H40.8889C41.9316 25.8889 42.7778 25.0446 42.7778 24C42.7778 22.9573 41.9316 22.1111 40.8889 22.1111ZM40.8889 37.2222H6.88889C5.84622 37.2222 5 38.0684 5 39.1111C5 40.1557 5.84622 41 6.88889 41H40.8889C41.9316 41 42.7778 40.1557 42.7778 39.1111C42.7778 38.0684 41.9316 37.2222 40.8889 37.2222ZM6.88889 10.7778H40.8889C41.9316 10.7778 42.7778 9.93344 42.7778 8.88889C42.7778 7.84622 41.9316 7 40.8889 7H6.88889C5.84622 7 5 7.84622 5 8.88889C5 9.93344 5.84622 10.7778 6.88889 10.7778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHamburg);
export default __webpack_public_path__ + "static/media/ic-hamburg.8377cb114bf5310b8a1687c9ab6274ac.svg";
export { ForwardRef as ReactComponent };